var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuba(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 10,
    viewBox: "0 0 19 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.11 5.125h-2.934v-.789a1.244 1.244 0 00-.357-.955 1.225 1.225 0 00-.948-.359h-1.174V1.708c0-.394 0-.394.653-.394a.712.712 0 00.652-.657c0-.263-.261-.657-.522-.657h-1.305a.702.702 0 00-.652.657v2.234H8.22a1.3 1.3 0 00-.922.385c-.245.246-.382.58-.382.929v.788h-2.87a2.376 2.376 0 00-1.493.507 2.406 2.406 0 00-.855 1.333h-.391v-.657a.622.622 0 00-.396-.619.609.609 0 00-.256-.038.609.609 0 00-.615.399.622.622 0 00-.038.258v2.497c.13.525.392.788.653.788a.609.609 0 00.614-.399.622.622 0 00.038-.258v-.657h.391c.124.532.425 1.005.851 1.341.427.337.955.518 1.497.512h12.13a2.47 2.47 0 001.753-.731 2.506 2.506 0 00.726-1.766 2.636 2.636 0 00-.822-1.677 2.598 2.598 0 00-1.722-.701z",
    fill: "#0433FF"
  })));
}

export default SvgSuba;